export const headerCells: Array<{ key: string; title: string; width: string }> =
  [
    { key: 'header_1', title: 'EMPLOYEE', width: '20%' },
    { key: 'header_2', title: 'VACATION PERIOD', width: '25%' },
    { key: 'header_3', title: 'LEAVE TYPE', width: 'calc(55% - 260px)' },
    { key: 'header_4', title: 'DOCUMENT STATUS', width: '260px' },
    { key: 'header_5', title: 'OPTIONS', width: '260px' },
  ];
